<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper"> <!-- :class="{'wrapper-app': this.isMobile()}" -->
            <div class="header"><h1>{{ $t('ordine_titolo') }}</h1></div>
            <div class="content text-center" style="min-height:560px;">
                <div class="title">{{ $t('ordine_scelta_titolo') }}</div>
                <lv1 v-if="this.conf_lv1"
                     :init-type="this.init_type"
                     :configurazioni="this.conf_lv1"
                     :curr-type="this.curr_type"
                     :address="this.curr_address"
                     :point="this.curr_point"
                     :table="this.curr_table"
                     @onButtonPress="this.onLv1ButtonPress"
                     @onIndirizzoManualeCittaPicked="this.onIndirizzoManualeCittaPicked"
                     @onIndirizzoManualeZonaPicked="this.onIndirizzoManualeZonaPicked"
                     @onIndirizzoCoordinatePicked="this.onIndirizzoCoordinatePicked"
                     @onPointPicked="this.onPointPicked"
                     @onQrCodeDecoded="this.onQrCodeDecoded"
                     @onQrCodeScanAgain="this.onQrCodeScanAgain"
                />
                <lv2 ref="lv2Component"
                     v-if="this.conf_lv2"
                     :init-people-number="this.init_people_number"
                     :init-day="this.init_day"
                     :configurazione="this.conf_lv2"
                     :curr-type="this.curr_type"
                     :numero-persone="this.conf_lv1.mangia_ristorante.numero_persone"
                     @onPeopleNumberChange="this.onPeopleNumberChange"
                     @onDayChange="this.onDayChange"
                />
                <lv3 v-if="this.conf_lv3"
                     :configurazione="this.conf_lv3"
                     :init-time="this.init_time"
                     :curr-type="this.curr_type"
                     @onTimeChange="this.onTimeChange"
                />
                <lv-final
                    v-if="this.conf_lv3 && this.conf_lv3.hours.length"
                    :curr-type="this.curr_type"
                    :f-asap="!!this.conf_lv1[this.curr_type].f_appena_possibile"
                    :curr-asap="this.curr_asap"
                    @onAsapChange="this.onAsapChange"
                    @onSeeMenuTap="this.onSeeMenuTap"
                />
                <div class="w-100 p-3 pt-0 f13" v-if="this.curr_status">
                  <i>{{ this.curr_status }}</i>
                </div>
                <div class="spinner-border mb-3" role="status" v-if="this.loading_visible">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <modal-confirm :header-title="$t('attenzione_label')"
                       :body-text="'Continuando i prodotti a carrello potrebbero essere rimossi. Procedere?'"
                       v-if="this.show_confirm_modal"
                       @close="onModalClose"
        />
    </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import moment from "moment";

import Lv1 from "./partials/options/Lv1";
import Lv2 from "./partials/options/Lv2";
import Lv3 from "./partials/options/Lv3";
import LvFinal from "./partials/options/LvFinal";

import {lv1 as getLv1, lv2 as getLv2, lv3 as getLv3} from "../../api/restaurant/shifts";
import {getOrder} from "../../api/account";
import {getProduct} from "../../api/restaurant";
import {canAddProductInCombo, getSurvivedItems, trovaConsegnaCitta, trovaConsegneCitta} from "../../libraries/utils";
import ModalConfirm from "../partials/ModalConfirm";


export default {
    name: "Options",
    components: {ModalConfirm, LvFinal, Lv3, Lv1, Lv2},
    data() {
        return {
            curr_address: null,
            init_type: null,
            init_people_number: null,
            init_day: null,
            init_time: null,
            conf_lv1: null,
            conf_lv2: null,
            conf_lv3: null,
            loading: true,
            curr_type: null,
            curr_people_number: null,
            curr_date: null,
            curr_time: null,
            curr_asap: null,
            curr_point: null,
            curr_table: null,
            show_confirm_modal: false,
            reorder_order_id: null
        }
    },
    created() {
        this.curr_address = this.order.address;
        this.curr_asap = this.order.f_appena_possibile;
        this.curr_type = this.order.type;
        this.curr_point = this.order.id_punto_di_servizio;
        this.curr_table = this.order.table;

        const reorderOrderId = parseInt(
            this.$route.query.reorder_order_id || this.$route.query.id_ordine || this.$route.query.order_id,
            10
        );
        this.reorder_order_id = Number.isInteger(reorderOrderId) && reorderOrderId > 0
            ? reorderOrderId
            : null;

        this.fetch();
    },
    computed: {
        curr_status: function () {
            const currentConf = this.conf_lv1 ? this.conf_lv1[this.curr_type] : null;
            if (!currentConf) {
                return this.$t('select_order_type');
            } else if (currentConf.f_forza_blocco || !currentConf.f_attivo) {
                return this.$t('ordine.bloccati_msg');
            }
        },
        f_ponyu_fasce_delivery: function () {
            return !!(this.locale.ponyu_api_key &&
                this.locale.f_ponyu_fasce_delivery
            );
        },
        f_eatintime_fasce_delivery: function () {
            return !!(this.locale.eatintime_api_key &&
                this.locale.f_eatintime_fasce_delivery
            );
        },
        ...mapState('localization', {
            language: (state) => state.language
        }),
        ...mapState('restaurant', {
            restaurant_id: state => state.id,
            locale: state => state.locale,
            f_modalita_fiera: state => state.f_modalita_fiera
        }),
        ...mapState('auth', {
            api_key: state => state.api_key
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        })
    },
    watch: {},
    methods: {
        isMobile() {
          return !!window.isKuokkoMobileApp;
        },
        fetch: function () {
            this.showLoading(true);
            getLv1(
                this.language, {
                    id_ristorante: this.restaurant_id,
                    id_locale: this.locale.id
                },
                this.api_key
            ).then((configurazioni) => {
                this.showLoading(false);

                let address = null;
                if(configurazioni.delivery.f_modalita_fasce_zona){
                    address = this.curr_address
                }

                if (!address && configurazioni.delivery.indirizzo_predefinito) {
                    const indirizzoPredefinito =
                        configurazioni.delivery.indirizzo_predefinito;

                    if (configurazioni.delivery.tipo_modalita_zone === 'MANUALE') {
                        // Trovo la consegna citta
                        let consegnaCittaDelPredefinito = configurazioni.delivery
                            .consegne_citta
                            ? configurazioni.delivery.consegne_citta.find((consegnaCitta) => {
                                let cond1 =
                                    consegnaCitta.id ===
                                    indirizzoPredefinito.indirizzo.id_consegna_citta;

                                if (cond1 && consegnaCitta.zone && consegnaCitta.zone.length) {
                                    return (
                                        cond1 &&
                                        consegnaCitta.zone.find((zona) => {
                                            return (
                                                zona.id ===
                                                indirizzoPredefinito.indirizzo.id_consegna_zona
                                            );
                                        })
                                    );
                                } else {
                                    return cond1;
                                }
                            })
                            : null;

                        if (consegnaCittaDelPredefinito) {
                            let zoneEsistono = !!consegnaCittaDelPredefinito.zone.length;

                            address = {
                                tipo: configurazioni.delivery.tipo_modalita_zone,
                                id_consegna_citta:
                                indirizzoPredefinito.indirizzo.id_consegna_citta,
                                id_consegna_zona:
                                indirizzoPredefinito.indirizzo.id_consegna_zona,
                                zone_enabled: zoneEsistono,
                                completed: true,
                            };
                        }
                    } else if (configurazioni.delivery.tipo_modalita_zone === 'COORDINATE') {
                        address = {
                            tipo: configurazioni.delivery.tipo_modalita_zone,
                            formatted_address: indirizzoPredefinito.formatted_address,
                            lat: indirizzoPredefinito.indirizzo.latitudine,
                            lng: indirizzoPredefinito.indirizzo.longitudine,
                            numero_civico: indirizzoPredefinito.indirizzo.numero,
                            id_consegna_citta:
                            indirizzoPredefinito.indirizzo.id_consegna_citta,
                            info: {
                                indirizzo: indirizzoPredefinito.indirizzo.indirizzo,
                                numero: indirizzoPredefinito.indirizzo.numero,
                                localita_citta: indirizzoPredefinito.indirizzo.localita_citta,
                                cap_citta: indirizzoPredefinito.indirizzo.cap_citta,
                                provincia: indirizzoPredefinito.indirizzo.provincia,
                                nazione: indirizzoPredefinito.indirizzo.nazione,
                            },
                            completed: true,
                        };
                    }
                }

                if (this.order.type) {
                    let type = this.order.type.toLowerCase();
                    this.init_type = configurazioni[type].f_attivo ? type : null;
                } else {
                    const activeConfigurations = [];
                    for (let key in configurazioni) {
                        if (configurazioni.hasOwnProperty(key)) {
                            if (key === "prenotazioni") continue;

                            if (configurazioni[key].f_attivo) {
                                activeConfigurations.push(key);
                            }
                        }
                    }

                    if (activeConfigurations.length === 1) {
                        this.init_type = activeConfigurations[0];
                    }
                }
                this.conf_lv1 = configurazioni;
                this.curr_address = address;
            }).catch(() => {
                this.showLoading(false);
            });
        },
        loadLv2: function (type, params = {}) {
            this.showLoading(true);
            const {address, point, table, consegneCittaTrovate} = params;
            this.conf_lv2 = null;
            this.conf_lv3 = null;
            if (address && address !== this.curr_address) {
                this.curr_address = address;
            }
            if (point && point !== this.curr_point) {
                this.curr_point = point;
            }
            if (table && table !== this.curr_table) {
                this.curr_table = table;
            }

            let id_consegna_citta;
            let id_consegna_zona = null;

            if (consegneCittaTrovate && consegneCittaTrovate.length) {
                id_consegna_citta = consegneCittaTrovate;
            } else if(this.conf_lv1[type].f_modalita_fasce_zona && address){
                id_consegna_citta = address.consegneCittaTrovate && address.consegneCittaTrovate.length ?  address.consegneCittaTrovate : address.id_consegna_citta;

                id_consegna_zona =
                    this.conf_lv1[type].f_modalita_fasce_zona && address
                        ? address.id_consegna_zona
                        : null;
            }

            getLv2(
                this.language,
                {
                    id_ristorante: this.restaurant_id,
                    id_locale: this.locale.id,
                    tipo: type,
                    id_consegna_citta,
                    id_consegna_zona,
                    id_punto_di_servizio: this.conf_lv1[type].f_modalita_fasce_zona
                        ? point
                        : null,
                },
                this.api_key,
            ).then((configurazioni) => {
                if (this.init_type) {
                    this.init_people_number = this.order.n_persone ? this.order.n_persone : null;
                    this.init_day = this.order.date
                        ? moment(this.order.date).format('YYYY-MM-DD')
                        : null;
                    this.init_time = this.order.date
                        ? moment(this.order.date).format('HH:mm')
                        : null;
                } else {
                    this.init_people_number = null;
                    this.init_day = null;
                    this.init_time = null;
                }

                this.conf_lv2 = configurazioni;
                if (!this.init_type) {
                    this.curr_asap = false;
                } else {
                    this.init_type = null;
                }
                this.$nextTick(() => {
                    this.scrollToLv2Title();
                });
                this.showLoading(
                    !!configurazioni.giorni.length &&
                    (this.f_ponyu_fasce_delivery || this.f_eatintime_fasce_delivery) &&
                    ['delivery', 'dil'].includes(type)
                );
            }).catch((e) => {
                console.log(e);
                this.showLoading(false);
            });
        },
        loadLv3: function () {
            this.showLoading(true);
            this.conf_lv3 = null;

            getLv3(
                this.language,
                {
                    id_ristorante: this.restaurant_id,
                    id_locale: this.locale.id,
                    tipo: this.curr_type,
                    id_consegna_citta: this.conf_lv1[this.curr_type].f_modalita_fasce_zona && this.curr_address && this.curr_address.id_consegna_citta ? this.curr_address.id_consegna_citta : '',
                    id_consegna_zona: this.conf_lv1[this.curr_type].f_modalita_fasce_zona && this.curr_address && this.curr_address.id_consegna_zona ? this.curr_address.id_consegna_zona : '',
                    data: this.curr_date,
                },
                this.api_key,
            ).then((configurazione) => {
                this.conf_lv3 = {
                    hours: configurazione.fasce,
                };
            }).catch(() => {
            }).finally(() => {
                this.showLoading(false);
            });
        },
        onLv1ButtonPress: function (type) {
            if (this.init_type || (type !== this.curr_type && !this.loading_visible)) {
                this.curr_type = type;
                this.conf_lv2 = null;
                this.conf_lv3 = null;

                if (!this.conf_lv1[type].f_forza_blocco) {
                    switch (type) {
                        case 'delivery':
                            //se non ho modalità fasce zona carico subito lv2
                            if (!this.conf_lv1[type].f_modalita_fasce_zona || this.curr_address) {
                                this.loadLv2(type, {address: this.curr_address});
                            }
                            break;
                        case 'dil':
                            if (this.f_modalita_fiera || this.curr_point) {
                                this.loadLv2(type, {point: this.curr_point});
                            } else if (this.conf_lv1[type].punti_di_servizio.length === 1) {
                                this.loadLv2(type, {point: this.conf_lv1[type].punti_di_servizio[0].id});
                            }
                            break;
                        case 'ordina_tavolo':
                            if (this.curr_table) {
                                this.loadLv2(type, {table: this.curr_table});
                            }
                            break;
                        default:
                            this.loadLv2(type);
                            break;
                    }
                }
            }
        },
        onIndirizzoManualeCittaPicked: function (city) {
            if (city) {
                let zoneEsistono = !!city.zone.length;

                let address = {
                    tipo: this.conf_lv1.delivery.tipo_modalita_zone,
                    id_consegna_citta: city.id,
                    id_consegna_zona: null,
                    zone_enabled: zoneEsistono,
                    completed: !zoneEsistono,
                };

                if (address.completed) {
                    this.loadLv2(this.curr_type, {address});
                } else {
                    this.curr_address = address;
                    this.conf_lv2 = null;
                    this.conf_lv3 = null;
                }
            } else {
                this.curr_address = null;
                this.conf_lv2 = null;
                this.conf_lv3 = null;
            }
        },
        onIndirizzoManualeZonaPicked: function (zona) {
            if (zona) {
                if (zona.id !== (this.curr_address ? this.curr_address.id_consegna_zona : null)) {
                    let address = Object.assign({}, this.curr_address, {
                        id_consegna_zona: zona.id,
                        completed: true,
                    });

                    this.loadLv2(this.curr_type, {address});
                }
            } else {
                this.curr_address.id_consegna_zona = null;
                this.curr_address.completed = false;
                this.conf_lv2 = null;
                this.conf_lv3 = null;
            }
        },
        onIndirizzoCoordinatePicked: function (geocodeResult, formattedAddress, houseNumber) {
            let consegneCittaTrovate = trovaConsegneCitta(
                this.conf_lv1.delivery.consegne_citta,
                geocodeResult.geometry.location.lng,
                geocodeResult.geometry.location.lat,
            ).sort((a, b) => {
                return a.area - b.area;
            }).map(({consegnaCitta}) => consegnaCitta.id);

            let address_components = geocodeResult.address_components;

            let indirizzo = address_components.find((address_component) => {
                return address_component.types.includes('route');
            });
            let localita_citta = address_components.find((address_component) => {
                return address_component.types.includes('administrative_area_level_3');
            })
            let cap_citta = address_components.find((address_component) => {
                return address_component.types.includes('postal_code');
            });
            let provincia = address_components.find((address_component) => {
                return address_component.types.includes('administrative_area_level_2');
            });
            let nazione = address_components.find((address_component) => {
                return address_component.types.includes('country');
            });

            let address = {
                tipo: this.conf_lv1.delivery.tipo_modalita_zone,
                formatted_address: formattedAddress,
                lat: geocodeResult.geometry.location.lat,
                lng: geocodeResult.geometry.location.lng,
                numero_civico: houseNumber,
                id_consegna_citta: null, //settato a null perchè sarà popolato quando verrà scelta la fascia oraria
                id_consegna_zona: null,
                info: {
                    indirizzo: indirizzo ? indirizzo.long_name : null,
                    numero: houseNumber,
                    localita_citta: localita_citta ? localita_citta.long_name : null,
                    cap_citta: cap_citta ? cap_citta.long_name : null,
                    provincia: provincia ? provincia.short_name : null,
                    nazione: nazione ? nazione.short_name : null,
                },
                completed: true,
                consegneCittaTrovate
            };

            this.loadLv2(this.curr_type, {address, consegneCittaTrovate});
        },
        onPointPicked: function (point) {
            if (point) {
                if (point !== this.curr_point) {
                    this.loadLv2(this.curr_type, {point});
                }
            } else {
                this.curr_point = null;
                this.conf_lv2 = null;
                this.conf_lv3 = null;
            }
        },
        onQrCodeDecoded: function (table) {
            if (table) {
                if (table !== this.curr_table) {
                    this.loadLv2(this.curr_type, {table});
                }
            } else {
                this.curr_table = null;
                this.conf_lv2 = null;
                this.conf_lv3 = null;
            }
        },
        onQrCodeScanAgain: function () {
            this.curr_table = null;
            this.conf_lv2 = null;
            this.conf_lv3 = null;
        },
        onPeopleNumberChange: function (value) {
            this.curr_people_number = value;
        },
        onDayChange: function (value, refinedValue) {
            this.curr_date = refinedValue;
            if (['delivery', 'dil'].includes(this.curr_type) && (this.f_ponyu_fasce_delivery || this.f_eatintime_fasce_delivery)) {
                this.loadLv3();
            } else {
                this.conf_lv3 = value;
            }
        },
        onTimeChange: function (time) {
            this.init_time = null;
            this.curr_time = time;

            if (['delivery'].includes(this.curr_type) && this.conf_lv1.delivery.f_modalita_fasce_zona && this.curr_address.lat){
                this.curr_address.id_consegna_citta = trovaConsegnaCitta(this.conf_lv1.delivery.consegne_citta.filter(consegna_citta => time.ids_consegna_citta.includes(consegna_citta.id)), this.curr_address.lng, this.curr_address.lat).id;
            }
        },
        onAsapChange: function (value) {
            this.curr_asap = value;
        },
        normalizeId: function (value) {
            if (value === undefined || value === null || value === '') {
                return null;
            }

            const parsed = parseInt(value, 10);
            return Number.isInteger(parsed) ? parsed : null;
        },
        getPriceForOrderType: function (price, orderType) {
            let finalPrice = price.prezzo;
            if (['ORDINA_TAVOLO', 'MANGIA_RISTORANTE'].includes(orderType) && price.prezzo_kmenu) {
                finalPrice = price.prezzo_kmenu;
            }

            return finalPrice;
        },
        getProductMeasure: function (product, price, orderType) {
            const measure = product.misure.find((item) => item.id === price.id_misura_tipologia_prodotto);
            if (!measure) return null;

            const standardPrice = product.prezzi.find((item) => {
                return item.id_misura_tipologia_prodotto === measure.id;
            });
            if (!standardPrice) return null;

            return {
                id: measure.id,
                nome: measure.nome,
                prezzo: this.getPriceForOrderType(standardPrice, orderType),
            };
        },
        getProductStandardMeasure: function (product, orderType) {
            const measure = product.misure.length ? product.misure[0] : null;
            if (!measure) return null;

            const standardPrice = product.prezzi.find((item) => {
                return item.id_misura_tipologia_prodotto === measure.id;
            });
            if (!standardPrice) return null;

            return {
                id: measure.id,
                nome: measure.nome,
                prezzo: this.getPriceForOrderType(standardPrice, orderType),
            };
        },
        getProductVariant: function (product, price, measure, orderType) {
            if (!product.varianti || !product.varianti.length) return null;

            const variant = product.varianti.find((item) => {
                return item.id === price.id_variante_tipologia_prodotto;
            });
            if (variant) {
                return {
                    id: variant.id,
                    nome: variant.nome,
                    prezzo: this.getPriceForOrderType(price, orderType) - measure.prezzo,
                };
            }

            if (product.variante_nome) {
                return {
                    id: null,
                    nome: product.variante_nome,
                };
            }

            return null;
        },
        buildProcessedAddsGroups: function (product, measureId) {
            const measureGroups = (product.aggiunte && product.aggiunte.misure_gruppi) ? product.aggiunte.misure_gruppi : [];
            const groups = ((product.aggiunte && product.aggiunte.gruppi) ? product.aggiunte.gruppi : [])
                .map((group) => ({
                    ...group,
                    processed_adds: [],
                    max_aggiunte: null,
                    aggiunte_gratis: null
                }));

            groups.forEach((group) => {
                const groupMeasure = measureGroups.find((measureGroup) => {
                    return measureGroup.id_misura_tipologia_prodotto === measureId &&
                        measureGroup.id_gruppo_aggiunte === group.id;
                });

                if (groupMeasure) {
                    group.max_aggiunte = groupMeasure.max_aggiunte;
                    group.aggiunte_gratis = groupMeasure.aggiunte_gratis;
                }
            });

            (product.aggiunte.ingredienti || []).forEach((ingredient) => {
                if (ingredient.mask_locali_esclusi & this.locale.id) return;

                const groupMeasure = measureGroups.find((measureGroup) => {
                    return measureGroup.id_misura_tipologia_prodotto === measureId &&
                        measureGroup.id_gruppo_aggiunte === ingredient.id_gruppo_aggiunte;
                });
                if (!groupMeasure) return;

                const override = (ingredient.misure_prezzi_override || []).find((item) => {
                    return item.id_misura_tipologia_prodotto === measureId;
                });

                const configuredPrice = override ? override.prezzo : groupMeasure.variazione_prezzo;
                const add = {
                    ...ingredient,
                    variazione_prezzo: configuredPrice,
                    variazione_prezzo_originale: configuredPrice,
                    f_override: !!override,
                };

                const group = groups.find((item) => item.id === add.id_gruppo_aggiunte);
                if (group) {
                    add.nome_gruppo_aggiunte = group.nome;
                    group.processed_adds.push(add);
                }
            });

            return groups;
        },
        getAddPrice: function (group, add, selectedAdds) {
            const alreadySelectedAdd = selectedAdds.find((selectedAdd) => {
                return selectedAdd.id_gruppo_aggiunte === group.id && selectedAdd.id === add.id;
            });
            if (alreadySelectedAdd) {
                return alreadySelectedAdd.variazione_prezzo;
            }

            const groupAdds = selectedAdds.filter((selectedAdd) => {
                return selectedAdd.id_gruppo_aggiunte === group.id;
            });

            return groupAdds.length < (Number(group.aggiunte_gratis) || 0) ? 0 : add.variazione_prezzo;
        },
        getRowAddsFromProduct: function (product, row, measureId) {
            if (!row.aggiunte || !row.aggiunte.length || !product.aggiunte || !product.aggiunte.ingredienti) {
                return [];
            }

            const groups = this.buildProcessedAddsGroups(product, measureId);
            const adds = [];

            row.aggiunte.forEach((orderAdd) => {
                const group = groups.find((item) => item.id === orderAdd.id_gruppo_aggiunte);
                if (!group) return;

                const processedAdd = group.processed_adds.find((item) => item.id === orderAdd.id_ingrediente);
                if (!processedAdd) return;

                if (group.max_aggiunte) {
                    const countAdds = adds.filter((currentAdd) => {
                        return currentAdd.id_gruppo_aggiunte === group.id;
                    }).length;

                    if (countAdds >= group.max_aggiunte) return;
                }

                if (adds.find((item) => item.id === processedAdd.id && item.id_gruppo_aggiunte === processedAdd.id_gruppo_aggiunte)) {
                    return;
                }

                const copiedAdd = JSON.parse(JSON.stringify(processedAdd));
                copiedAdd.variazione_prezzo = this.getAddPrice(group, copiedAdd, adds);
                adds.push(copiedAdd);
            });

            return adds;
        },
        buildProcessedFreePicksGroups: function (product, measureId) {
            const measureGroups = (product.scelte_libere && product.scelte_libere.misure_gruppi)
                ? product.scelte_libere.misure_gruppi
                : [];
            const groups = ((product.scelte_libere && product.scelte_libere.gruppi) ? product.scelte_libere.gruppi : [])
                .map((group) => ({
                    ...group,
                    processed_free_picks: [],
                }));

            (product.scelte_libere.ingredienti || []).forEach((ingredient) => {
                if (ingredient.mask_locali_esclusi & this.locale.id) return;

                const groupMeasure = measureGroups.find((measureGroup) => {
                    return measureGroup.id_misura_tipologia_prodotto === measureId &&
                        measureGroup.id_gruppo_aggiunte === ingredient.id_gruppo_aggiunte;
                });
                if (!groupMeasure) return;

                const override = (ingredient.misure_prezzi_override || []).find((item) => {
                    return item.id_misura_tipologia_prodotto === measureId;
                });

                const freePick = {
                    ...ingredient,
                    variazione_prezzo: override ? override.prezzo : groupMeasure.variazione_prezzo,
                    variazione_prezzo_originale: groupMeasure.variazione_prezzo,
                    f_override: !!override,
                };

                const group = groups.find((item) => item.id === freePick.id_gruppo_aggiunte);
                if (group) {
                    freePick.nome_gruppo_aggiunte = group.nome;
                    group.processed_free_picks.push(freePick);
                }
            });

            return groups;
        },
        canAddFreePick: function (freePick, freePicks, maxPicks, maxTastes) {
            if (maxPicks && freePicks.length >= maxPicks) return false;

            if (maxTastes) {
                const currentTastes = freePicks
                    .filter((item, index) => {
                        return item && freePicks.findIndex((candidate) => item.id === candidate.id) === index;
                    })
                    .map((item) => item.id);

                if (currentTastes.length >= maxTastes && !currentTastes.includes(freePick.id)) {
                    return false;
                }
            }

            return true;
        },
        getRowFreePicksFromProduct: function (product, row, measureId) {
            if (!row.scelte_libere || !row.scelte_libere.length || !product.scelte_libere || !product.scelte_libere.ingredienti) {
                return [];
            }

            const groups = this.buildProcessedFreePicksGroups(product, measureId);
            const freePicks = [];

            row.scelte_libere.forEach((orderFreePick) => {
                const group = groups.find((item) => item.id === orderFreePick.id_gruppo_aggiunte);
                if (!group) return;

                const processedFreePick = group.processed_free_picks.find((item) => {
                    return item.id === orderFreePick.id_ingrediente;
                });
                if (!processedFreePick) return;

                if (this.canAddFreePick(
                    processedFreePick,
                    freePicks,
                    product.max_scelte_libere,
                    product.max_gusti_scelte_libere
                )) {
                    freePicks.push(processedFreePick);
                }
            });

            return freePicks;
        },
        getRowComboPicksFromProduct: function (product, row) {
            if (
                !row.f_prodotto_composto ||
                !product.f_prodotto_composto ||
                !product.prodotto_composto_categorie_selezionabili ||
                !row.prodotto_composto_contenuto ||
                !row.prodotto_composto_contenuto.length
            ) {
                return [];
            }

            const picked = [];

            row.prodotto_composto_contenuto.forEach((content) => {
                const category = product.prodotto_composto_categorie_selezionabili.find((item) => {
                    return item.id_categoria === content.id_categoria;
                });
                if (!category) return;

                const pickedProduct = category.prodotti.find((item) => {
                    return item.id_prodotto === content.id_prodotto;
                });
                if (!pickedProduct) return;

                const pickedProductQta = parseInt(content.qta, 10) || 0;

                for (let i = 0; i < pickedProductQta; i++) {
                    if (!canAddProductInCombo(
                        category,
                        picked,
                        product.prodotto_composto_max_prod
                    )) {
                        return;
                    }

                    const pickIndex = picked.findIndex((pick) => {
                        return pick.id_categoria === category.id_categoria &&
                            pick.id_prodotto === pickedProduct.id_prodotto;
                    });

                    if (pickIndex !== -1) {
                        picked[pickIndex].qta++;
                        picked[pickIndex].totale = picked[pickIndex].prezzo * picked[pickIndex].qta;
                    } else {
                        picked.push({
                            id_prodotto_composto_categoria_prodotto: pickedProduct.id,
                            id_prodotto_composto_categoria: category.id,
                            id_categoria: category.id_categoria,
                            nome_categoria: category.nome_categoria,
                            nome_prodotto: pickedProduct.nome_prodotto,
                            id_prodotto: pickedProduct.id_prodotto,
                            qta: 1,
                            prezzo: pickedProduct.prezzo,
                            totale: pickedProduct.prezzo,
                            ingredienti: pickedProduct.ingredienti,
                            foto_codice: pickedProduct.foto_codice,
                        });
                    }
                }
            });

            return picked;
        },
        reOrder: async function (orderId) {
            try {
                const {ordine} = await getOrder(this.language, {
                    id_ristorante: this.restaurant_id,
                    id_locale: this.locale.id,
                    api_key: this.api_key,
                    id: orderId,
                });

                this.destroyOrderCart();

                let totalQta = 0;
                let realQta = 0;
                const activeOrderType = (this.curr_type || '').toUpperCase();

                for (const row of (ordine.righe || [])) {
                    const rowQta = parseInt(row.qta, 10) || 0;
                    totalQta += rowQta;
                    if (!rowQta) continue;

                    const {prodotto} = await getProduct(this.language, {
                        id_ristorante: this.restaurant_id,
                        id_prodotto: row.id_prodotto,
                        id_categoria_prodotto: row.id_categoria,
                        id_locale: this.locale.id,
                        id_menu: this.curr_time ? this.curr_time.id_menu : null,
                        ultimo_aggiornamento: false,
                    });

                    if (!prodotto) continue;
                    if (!prodotto.f_disponibile) continue;
                    if (this.locale.id & prodotto.mask_locali_esclusi) continue;

                    let price = prodotto.prezzi.find((item) => {
                        return item.id_misura_tipologia_prodotto === row.id_misura &&
                            item.id_variante_tipologia_prodotto === row.id_variante;
                    });
                    if (!price) {
                        price = prodotto.prezzi.find((item) => {
                            return item.id_misura_tipologia_prodotto === row.id_misura;
                        }) || prodotto.prezzi[0];
                    }
                    if (!price) continue;

                    const measure = this.getProductMeasure(prodotto, price, activeOrderType);
                    const standardMeasure = this.getProductStandardMeasure(prodotto, activeOrderType);
                    if (!measure || !standardMeasure) continue;

                    const variant = this.getProductVariant(prodotto, price, measure, activeOrderType);
                    const adds = this.getRowAddsFromProduct(prodotto, row, measure.id);
                    const freePicks = this.getRowFreePicksFromProduct(prodotto, row, measure.id);
                    const picked = this.getRowComboPicksFromProduct(prodotto, row);

                    if (this.normalizeId(variant ? variant.id : null) !== this.normalizeId(row.id_variante)) {
                        continue;
                    }
                    if (adds.length !== (row.aggiunte || []).length) continue;
                    if (freePicks.length !== (row.scelte_libere || []).length) continue;
                    if (picked.length !== (row.prodotto_composto_contenuto || []).length) continue;

                    this.modifyOrderItem({
                        item: {
                            id: prodotto.id,
                            id_tipologia_prodotto: prodotto.id_tipologia_prodotto,
                            price: price,
                            adds: adds,
                            free_picks: freePicks,
                            note: row.note,
                            nome: prodotto.nome,
                            proportion: measure,
                            standard_proportion: standardMeasure,
                            variant: variant,
                            category_id: prodotto.categoria ? prodotto.categoria.id : row.id_categoria,
                            f_sconto: prodotto.f_sconto,
                            f_prodotto_composto: prodotto.f_prodotto_composto,
                            prodotto_composto_tipo_prezzo: prodotto.prodotto_composto_tipo_prezzo,
                            prodotto_composto_associati: picked,
                        },
                        quantity: rowQta,
                        menu_presenti: prodotto.menu_presenti || [],
                        f_delivery: prodotto.f_delivery,
                        prodotti_suggeriti: prodotto.prodotti_suggeriti || [],
                    });

                    realQta += rowQta;
                }

                return realQta !== totalQta;
            } catch (errors) {
                const apiErrors = errors && errors.messages
                    ? (Array.isArray(errors.messages) ? errors.messages : [errors.messages])
                    : ['Errore durante il riordino'];

                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: apiErrors,
                });

                return true;
            }
        },
        onModalClose: function (success) {
            this.show_confirm_modal = false;
            if (success) this.goOn();
        },
        goOn: async function () {
            this.resetOrderTimers();
            this.setOrderOptions({
                type: this.curr_type.toUpperCase(),
                date: this.curr_date + ' ' + this.curr_time.from + ':00',
                id_menu: this.curr_time.id_menu,
                id_orario: this.curr_time.id_orario,
                f_appena_possibile: ['delivery', 'dil'].includes(this.curr_type) ? this.curr_asap : false,
                n_persone: ['mangia_ristorante', 'ordina_tavolo'].includes(this.curr_type) ? this.curr_people_number : null,
                fine_fascia: ['delivery', 'dil'].includes(this.curr_type) ? this.curr_time.to + ':00' : null,
                id_locale: this.locale.id,
                address: this.curr_type === 'delivery' ? this.curr_address : null,
                id_punto_di_servizio: this.curr_type === 'dil' ? this.curr_point : null,
                label_tipologia: this.conf_lv1[this.curr_type]?.label_tipologia,
                table: this.curr_type === 'ordina_tavolo' ? this.curr_table : null
            });

            if (this.reorder_order_id) {
                this.showLoading(true);
                const partialReorder = await this.reOrder(this.reorder_order_id);
                this.showLoading(false);
                this.reorder_order_id = null;

                await this.$router.push({name: 'cart'});
                if (partialReorder) {
                    this.showModalErrors({
                        title: this.$t('attenzione_label').toUpperCase(),
                        errors: [this.$t('carrello.prd_non_disponibili_msg')]
                    });
                }
                return;
            }

            if (this.order.items.length) {
                this.replaceOrderItems(
                    getSurvivedItems(
                        this.order.items,
                        this.curr_type.toUpperCase(),
                        this.curr_time.id_menu
                    )
                );
            }

            await this.$router.push({name: 'menu.categories'});
        },
        onSeeMenuTap: function () {
            const confirmTrigger = ['MANGIA_RISTORANTE', 'ORDINA_TAVOLO'];
            const selectedOrderType = (this.curr_type || '').toUpperCase();
            const currentOrderType = (this.order.type || '').toUpperCase();

            if (
                this.order.total_items && this.order &&
                ((confirmTrigger.includes(selectedOrderType) &&
                        !confirmTrigger.includes(currentOrderType)) ||
                    (confirmTrigger.includes(currentOrderType) &&
                        !confirmTrigger.includes(selectedOrderType)))
            ) {
                this.show_confirm_modal = true;
            } else {
                this.goOn();
            }

        },
        scrollToLv2Title: function () {
            if (this.$refs.lv2Component && this.$refs.lv2Component.$el) {
                const titleElement = this.$refs.lv2Component.$el.querySelector('.title');
                if (titleElement) {
                    titleElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        },
        ...mapActions('global', {
            showLoading: 'showLoading',
            showModalErrors: 'showModalErrors'
        }),
        ...mapActions('order', {
            setOrderOptions: 'setOptions',
            replaceOrderItems: 'replaceItems',
            modifyOrderItem: 'modifyItem',
            destroyOrderCart: 'destroyCart',
            resetOrderTimers: 'resetTimers',
        })
    }
}
</script>
